/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



$(document).ready(function() {
  //toggle the component with class accordion_body
  $(".accordion_head").click(function() {
    if ($('.accordion_body').is(':visible')) {
      $(".accordion_body").slideUp(300);
      $(".plusminus").text('+');
    }
    if ($(this).next(".accordion_body").is(':visible')) {
      $(this).next(".accordion_body").slideUp(300);
      $(this).children(".plusminus").text('+');
    } else {
      $(this).next(".accordion_body").slideDown(300);
      $(this).children(".plusminus").text('-');
    }
  });
});


  var slider = tns({
    container: '.my-slider',
//   "edgePadding": 350,
//   "fixedWidth": 400,
  "swipeAngle": false,
  "speed": 400,
//     items:1,
   "mouseDrag": true,
    "responsive": {
    	"1200": {
      		"items": 1,
        	"edgePadding": 350
    	},
      "1100": {
      		"items": 1,
        	"edgePadding": 250
    	},
        "960": {
      		"items": 1,
        	"edgePadding": 50
    	},
        "800": {
      		"items": 1,
        	"edgePadding": 0
    	},
    	"767": {
      		"items": 1,
        	"edgePadding": 0,
	    }
  	},
  });






